import { ActivityIndicator, Linking, StyleSheet, View } from 'react-native'
import CreateSessions from '../CreateSessions'
import { CustomText } from '../../../text/StyledText'
import { txt } from '../../../../locales/i18n'
import IconNames from '../../../../constants/IconNames'
import OwnBookedSessions from '../OwnBookedSessions'
import OwnNotBookedSessions from '../OwnNotBookedSessions'
import AllSessions from '../../../shared/AllSessions'
import React, { useEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/core'
import { getAllSessions, getOwnBooked, getOwnNotBooked } from '../../../../services/api/snakSammen'
import Layout from '../../../../constants/Layout'
import Colors from '../../../../constants/Colors'
import { SpacingStyles } from '../../../../styles'
import PhoneInputForm from '../../../formElements/PhoneInputForm'
import { useSelector } from 'react-redux'
import NormalIcon from '../../../icons/NormalIcon'
import CustomPressable from "../../../pressables/CustomPressable"

export default function MySessions() {
  const navigation = useNavigation()
  const [sessions, setSessions] = useState(null)
  const [ownBookedSessions, setOwnBookedSessions] = useState([])
  const [ownNotBookedSessions, setOwnNotBookedSessions] = useState([])
  const [reloading, setReloading] = useState(false)
  const phoneNumber = useSelector((state) => state.user.phone)

  const getOwnBookedSessions = async () => {
    const data = await getOwnBooked()
    const sessions = data.map(function (val, index) {
      return {
        key: index,
        id: val.id,
        start_date: val.start_date,
        end_date: val.end_date,
        room_key: val.room_key,
        vonage_session_id: val.vonage_session_id,
        username: val.username,
        bookerId: val.booker_id,
      }
    })

    setOwnBookedSessions(sessions)
  }

  const getOwnNotBookedSessions = async () => {
    const data = await getOwnNotBooked()
    const res = data.map(function (val, index) {
      return {
        key: index,
        id: val.id,
        start_date: val.start_date,
        end_date: val.end_date,
        username: val.username,
      }
    })
    setOwnNotBookedSessions(res)
  }

  const navigateToConversation = (conversationId) => {
    navigation.navigate('InboxStack', {
      screen: 'Conversation',
      initial: false,
      params: {
        id: conversationId,
      },
    })
  }

  const navigateToNewConversation = (userId, sessionId) => {
    navigation.navigate('InboxStack', {
      screen: 'Conversation',
      initial: false,
      params: {
        id: 'new',
        receiverId: userId,
        vsSessionId: sessionId,
      },
    })
  }

  useEffect(() => {
    reloadAll()
  }, [])

  async function reloadAll() {
    setReloading(true)
    const sessions = await getAllSessions()
    const ownBookedSessions = await getOwnBooked()
    const ownNotBookedSessions = await getOwnNotBooked()

    setSessions(sessions)
    setOwnBookedSessions(ownBookedSessions)
    setOwnNotBookedSessions(ownNotBookedSessions)
    setReloading(false)
  }

  return (
    <View style={styles.container}>
      {(phoneNumber === 0 || !phoneNumber) && (
        <>
          <PhoneInputForm />
          <View style={styles.separator} />
        </>
      )}
      <CreateSessions reloadAll={reloadAll} />
      <View style={styles.separator} />
      <CustomPressable onPress={reloadAll} style={styles.reload}>
        <CustomText style={{ marginRight: 6 }}>{txt('learnDanish.update')}</CustomText>
        {reloading ? (
          <ActivityIndicator />
        ) : (
          <NormalIcon name={IconNames.reload} style={{ margin: 2 }} color={Colors.text} size={16} />
        )}
      </CustomPressable>
      <OwnBookedSessions
        reloadAll={reloadAll}
        ownBookedSessions={ownBookedSessions}
        getOwnBookedSessions={getOwnBookedSessions}
        navigateToConversation={navigateToConversation}
        navigateToNewConversation={navigateToNewConversation}
      />
      <OwnNotBookedSessions
        reloadAll={reloadAll}
        ownNotBookedSessions={ownNotBookedSessions}
        getOwnNotBookedSessions={getOwnNotBookedSessions}
      />
      <CustomText font="italic" style={styles.support}>
        {txt('learnDanish.supportPhone')}
        <CustomPressable onPress={() => Linking.openURL('tel:81740740')}>
          <CustomText font="italic" style={styles.phoneNumber}>
            {txt('learnDanish.supportPhoneNumber')}
          </CustomText>
        </CustomPressable>
      </CustomText>
      <View style={styles.separator} />
      <AllSessions sessions={sessions} service="snaksammen" />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: Layout.maxFeedWidth,
    alignSelf: 'center',
    marginVertical: 12,
  },
  support: { margin: 12 },
  phoneNumber: { color: Colors.tintColor },
  separator: {
    borderBottomColor: Colors.inactive,
    borderBottomWidth: 1,
    marginBottom: 10,
    marginTop: 20,
    ...SpacingStyles.marginRightLeft10,
    opacity: 0.3,
    zIndex: -1,
  },
  reload: {
    alignSelf: 'flex-end',
    marginRight: 24,
    flexDirection: 'row',
    alignItems: 'center',
  },
})
